import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { LambdaListEditor } from 'config-editor';
import { Lambda } from 'config-editor-common';
import { useRecordField } from '../fieldState';

interface UiOptions {
  defaultsFieldName?: string;
}

type Props = FieldExtensionComponentProps<Record<string, Lambda>, UiOptions>;

export const LambdaEditor = (props: Props) => {
  const { schema, uiSchema } = props;
  const title = schema.title || uiSchema?.['ui:title'] || 'Lambdas';
  const description =
    schema.description || uiSchema?.['ui:description'] || 'Configure lambda functions';
  const { items, defaults, commit } = useRecordField<Lambda>(props);

  return (
    <LambdaListEditor
      lambdas={items}
      onChange={commit}
      defaults={defaults}
      title={title}
      description={description}
      showPaper
    />
  );
};
